import { protectedResources } from '../../authConfig';
import makeGetRequestAsync from '../Helpers/httpRequestHelpers';

const apiScopes = protectedResources.companyApi.scopes;
const baseUrl = protectedResources.companyApi.endpoint;

export interface FeatureFlags {
  branchOnboarding: boolean;
}

/**
 * Fetches the evaluated feature-flag states from the Company API.
 * The backend is the single source of truth; this call is cached by React Query
 * via {@link useFeatureFlags}.
 */
export async function getFeatureFlags(): Promise<FeatureFlags> {
  // NOTE: must match the controller route exactly — FeatureFlagsController is
  // [Route("api/Company/[controller]")] => /api/Company/FeatureFlags. A kebab-case
  // path 404s (the route has no hyphen), and useFeatureFlags then silently falls back
  // to branchOnboarding=false, disabling the feature even where the backend has it ON.
  const url = `${baseUrl}/api/Company/FeatureFlags`;
  const response = await makeGetRequestAsync<FeatureFlags>(apiScopes, url);
  return response.data;
}
